import { api } from "./api";

const userService = {
  getAllUsers: async () => {
    const response = await api.get("/users");
    return response.data;
  },

  getFilteredUsers: async (filters = {}) => {
    // Build query string from filters
    const params = new URLSearchParams();

    if (filters.status) params.append('status', filters.status);
    if (filters.licenseStatus) params.append('licenseStatus', filters.licenseStatus);
    if (filters.role) params.append('role', filters.role);
    if (filters.productId) params.append('productId', filters.productId);
    if (filters.hardwareStatus) params.append('hardwareStatus', filters.hardwareStatus);
    if (filters.expiringDays) params.append('expiringDays', filters.expiringDays);
    if (filters.search) params.append('search', filters.search);

    const response = await api.get(`/users/filtered?${params.toString()}`);
    return response.data;
  },

  updateUser: async (userId, userData) => {
    // Ensure hardware_ids is properly handled
    if (
      userData.hardwareId &&
      (!userData.hardware_ids || !Array.isArray(userData.hardware_ids))
    ) {
      userData.hardware_ids = [userData.hardwareId];
    }

    const response = await api.put(`/users/${userId}`, userData);
    return response.data;
  },

  addHardwareId: async (userId, hardwareId) => {
    const response = await api.post(`/users/${userId}/hardware-ids`, {
      hardwareId,
    });
    return response.data;
  },

  deleteUser: async (userId) => {
    const response = await api.delete(`/users/${userId}`);
    return response.data;
  },

  changeUserPassword: async (userId, passwordData) => {
    const response = await api.post(`/users/${userId}/change-password`, passwordData);
    return response.data;
  },
};

export { userService };